import { useCallback } from 'react';
import type { ReduceNoiseValue } from '../../lib/filters/reduce-noise';
import type { AdjustmentPanelProps } from '../adjustments/registry';
import { RangeRow } from '../adjustments/RangeRow';

/** Reduce Noise panel — three sliders. Radius is capped at the
 *  algorithm's hard cap (5); larger windows would blow the live-
 *  preview budget. */
export function ReduceNoisePanel({ value, onChange }: AdjustmentPanelProps<ReduceNoiseValue>) {
  const set = useCallback(
    (patch: Partial<ReduceNoiseValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );
  return (
    <div className="space-y-3">
      <RangeRow
        label="Strength"
        min={0}
        max={100}
        step={1}
        value={value.strength}
        onChange={(v) => set({ strength: v })}
      />
      <RangeRow
        label="Radius"
        min={1}
        max={5}
        step={1}
        value={value.radius}
        onChange={(v) => set({ radius: v })}
      />
      <RangeRow
        label="Edge Detail"
        min={1}
        max={100}
        step={1}
        value={value.rangeSigma}
        onChange={(v) => set({ rangeSigma: v })}
      />
    </div>
  );
}
